module.exports = __webpack_public_path__ + "img/instinct.f5f4050d.svg";